import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/main.scss'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// 引入响应式适配方案
import responsive from './utils/responsive'
import './styles/responsive.css'

// 初始化响应式适配
// 确保在Vue实例创建之前初始化
if (typeof window !== 'undefined') {
  responsive.init()
}

// 将响应式工具函数挂载到Vue原型上，方便组件内使用
Vue.prototype.$responsive = responsive

// 添加全局错误处理
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue错误:', err, info)
}

import {
  Button, Form, FormItem, Option, Select, Input, Empty, InputNumber, Divider, Pagination, Popover, Dropdown,
  DropdownMenu,
  DropdownItem,
} from 'element-ui';

Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Empty);
Vue.use(Option);
Vue.use(InputNumber);
Vue.use(Divider);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')